export const getUUID = () => {
    let profileData = window.localStorage.getItem("janrainCaptureProfileData");
    let usersID;
    if (profileData) {
        usersID = JSON.parse(profileData).uuid;
    }
    return usersID;
};
